'use client';

import { useProductQuantity } from '@eliadmin/core/src/components/dlz/product-detail/buy-box/use-product-quantity';
import { QuantityStepper } from '@eliadmin/core/src/components/dlz/ui/quantity';
import { AddToCartButton } from '@eliadmin/core/src/components/product/add-to-cart-button';
import { AddToFavoritesButton } from '@eliadmin/core/src/components/product/add-to-favorites-button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';
import { useVariantsStore } from '@eliadmin/core/src/stores/variant-store';
import { hasDimensions } from '@eliadmin/core/src/utils/product-utils';

/**
 * Figma „Actions“: quantity stepper, „Pridať do košíka“ and the favourite button. The cart flow
 * (variant dialog, `skip_variant_dialog`, the „Pridané do košíka“ dialog) is the core
 * `AddToCartButton`; a supplier with an affiliate link replaces the stepper with its link button.
 */
export function CartRow() {
  const { t } = useTranslations();
  const settings = useGlobalStore(state => state.templateSettings.product_detail);
  const product = useVariantsStore(state => state.product);
  const customValuesError = useVariantsStore(state => state.customValuesError);
  const quantity = useProductQuantity();

  const firstSupplier = [...(product.suppliers ?? [])].sort((a, b) => a.position - b.position)[0];

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
      {firstSupplier?.is_affiliate ? null : (
        <QuantityStepper
          label={t('text22')}
          value={quantity.quantity}
          step={quantity.step}
          onCommit={quantity.setQuantity}
          min={quantity.minQuantity}
          disabled={quantity.disabled}
          className="h-12 w-full sm:w-[148px] lg:h-[52px]"
        />
      )}
      <div className="flex min-w-0 items-center gap-3 sm:flex-1">
        <AddToCartButton
          product={product}
          quantity={quantity.quantity}
          sellable={quantity.sellable}
          disabled={quantity.disabled || (hasDimensions(product.attributes) && customValuesError)}
          skipVariantDialog={settings?.skip_variant_dialog?.enabled}
          customText="text227"
          iconLeft="cart"
          // The core button renders its caption in two spans, the first one flex-1: keep icon and
          // caption together in the centre.
          className="h-12 min-w-0 flex-1 space-x-0 lg:h-[52px] [&>span]:flex-none"
        />
        {settings?.add_to_favorite?.enabled ? (
          <AddToFavoritesButton
            slug={product.slug}
            productId={product.id}
            isFavorite={product.is_favorite ?? false}
            buttonVariant="outline"
            buttonSize="icon"
            buttonClassName="size-12 lg:size-[52px]"
            className="size-6 text-current hover:text-current"
          />
        ) : null}
      </div>
    </div>
  );
}
